export default __webpack_public_path__ + "static/media/authenticator-logo.24f2e6c9.svg";